/*This code keeps track of the basket total and updates the message on PDP
to ensure minimum order value is met. There is an existing plugin (MinMaxify)
that handles this functionality at cart. This code uses an additional minimum
order value field set in theme editor settings. It does not use the value 
from the plugin*/

document.addEventListener('DOMContentLoaded', function () {

    //Get Minimum Spend Value
    var minimumValueEl = document.querySelector('.minimum-value');
    var minimumSpend = parseFloat(minimumValueEl.textContent);
    if (!minimumValueEl) return;

    function updateMinimumSpend(cartTotal, minimumSpend) {
        var remainingSpend = minimumSpend - cartTotal;
        var remainingEl = document.querySelector('.remaining-spend');
        var messageEl = document.querySelector('.minimum-order-value');

        if (!remainingEl || !messageEl) return;

        messageEl.classList.add('loaded');

        if (remainingSpend > 0) {
            //Update remaining spend
            remainingEl.textContent = remainingSpend.toFixed(2);
            messageEl.classList.remove('minimum-met');
        } else {
            //Minimum value met
            messageEl.classList.add('minimum-met');            
        }
    }

    // Fetch cart and update the remaining balance
    function updateFromCart() {
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            updateMinimumSpend(cart.total_price / 100, minimumSpend);
        });
    }

    window.addEventListener('cartcount:update', function (event) {
        const cart = event.detail;
        console.log(cart.total_price / 100);
        console.log(minimumSpend);
        updateMinimumSpend(cart.total_price / 100, minimumSpend);  

        //Additional dietary message refresh at same time.
        fetch('/?sections=static-cart')
        .then(response => response.json())
        .then(data => {
            const parser = new DOMParser();
            const newDocument = parser.parseFromString(
                data['static-cart'],
                'text/html'
            );

            const newMessage = newDocument.querySelector('.basket-dietary-message');
            const currentMessage = document.querySelector('.basket-dietary-message');

            if (newMessage && currentMessage) {
                currentMessage.replaceWith(newMessage);
            } else if (!newMessage && currentMessage) {
                currentMessage.remove();
            }
        });    
    });

    // Initial run on page load
    updateFromCart();
});